import api from "@/api";

const state = {
    list: [],
};

const getters = {
    list(state) {
        return state.list.map(l => {
            return { _id: l.location, name: l.location };
        });
    },
};

const actions = {
    getList({ commit }) {
        return api.get(`/api/users/location`).then(res => {
            commit("updateList", { list: res.data });
        });
    },
};

const mutations = {
    updateList(state, { list }) {
        state.list = [...list];
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
